import { ErrorView } from "components/ErrorView/ErrorView";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const UserDetailsPage = React.lazy(() => import("./pages/UserDetailsPage/UserDetailsPage"));
const OnboardingModule = React.lazy(() => import("./OnboardingModule"));

export const OnboardingModuleRoutes: RouteObject = {
  path: "onboarding/",
  element: <PageRoute El={OnboardingModule} />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "user-details",
      element: <PageRoute El={UserDetailsPage} />,
    },
  ],
};
export default OnboardingModuleRoutes;
